export default import.meta.ROLLUP_FILE_URL_gZauu$cWc8EQGAq17G4vdQ